import { render, staticRenderFns } from "./CalculationTabs.vue?vue&type=template&id=2f06299a&"
import script from "./CalculationTabs.vue?vue&type=script&lang=js&"
export * from "./CalculationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports